<template>
  <div class="number-list">
    <div
      v-for="(item,itemIndex) in itemList"
      :key="itemIndex"
      class="number"
    >
      {{ item.title }}<span class="blue-number">{{ item.number }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "NumberList",
  props: {
    itemList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/number-list";
</style>